import React from 'react';
import SvgIcon from '../../../../core/icons/SvgIcon';
import { combineClassNames } from '../../../../core/css';

const CGISpinner = ({ width, height, className }) => {
  return (
    <div className={combineClassNames(['cgi-spinner', className])}>
      <img
        className="cgi-spinner__placeholder"
        src={`data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="${width}"  height="${height}" %3E%3C/svg%3E`}
      />
      <SvgIcon
        name="spinner"
        className="cgi-spinner__spinner svg-icon--option"
      />
    </div>
  );
};

export default CGISpinner;
